import { render, staticRenderFns } from "./share_card.vue?vue&type=template&id=397d1089&scoped=true"
import script from "./share_card.vue?vue&type=script&lang=js"
export * from "./share_card.vue?vue&type=script&lang=js"
import style0 from "./share_card.vue?vue&type=style&index=0&id=397d1089&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397d1089",
  null
  
)

export default component.exports